import { createContext } from "react";

export const OverlayOwnerContext = createContext<string | null>(null);

export const focusableElements = (root: HTMLElement): HTMLElement[] =>
    Array.from(
        root.querySelectorAll<HTMLElement>(
            'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex="0"]'
        )
    ).filter(
        (element) =>
            element.tabIndex >= 0 &&
            element.getClientRects().length > 0 &&
            !element.closest('[inert],[aria-hidden="true"]')
    );

export const ownedOverlays = (owner: string): HTMLElement[] =>
    Array.from(
        document.querySelectorAll<HTMLElement>("[data-overlay-owner]")
    ).filter((element) => element.dataset.overlayOwner === owner);
